import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import apiService from '../Common/Configurations/APIService';
import config from '../Common/Configurations/APIConfig';
import DefaultData from '../CompanyData/DefaultData';

export default function ResetPassword() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [token, setToken] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    useEffect(() => {
    const emailFromUrl = searchParams.get("email");

    const rawParams = new URLSearchParams(window.location.search);
    const tokenFromUrl = rawParams.get("token"); // This gets the raw value
    const queryString = searchParams.toString();
    const tokenMatch = queryString.match(/token=([^&]*)/);
    const rawToken = tokenMatch ? tokenMatch[1] : null;


    if (!emailFromUrl || !rawToken) {
        // If parameters are missing, redirect to home page
        console.error("Email or token missing from URL.");
        navigate('/');
    } else {
        setEmail(emailFromUrl);
        setToken(rawToken); // Set the RAW, ENCODED token
    }
}, [searchParams, navigate]);

    const validate = () => {
        if (!password || !confirmPassword) {
            setError("Both password fields are required.");
            return false;
        }
        if (password.length < 6) {
            setError("Password must be at least 6 characters long.");
            return false;
        }
        if (password !== confirmPassword) {
            setError("Passwords do not match.");
            return false;
        }
        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccessMessage('');

        if (validate()) {
            setIsLoading(true);
            const formData = {
                email: email,
                password: password,
                 token: token.trim(),
                domainUrl: window.location.origin
            };

            try {
                const result = await apiService.post(config.RESETPASSWORD, formData);
                setSuccessMessage(result.message || "Your password has been reset successfully!");
                // After a short delay, redirect to the home page
                setTimeout(() => {
                    navigate('/');
                }, 3000);
            } catch (err) {
                setError(err.response?.data?.message || "Failed to reset password. The link may be expired.");
            } finally {
                setIsLoading(false);
            }
        }
    };

    return (
        <div className="d-flex align-items-center justify-content-center min-vh-100 bg-light">
            <div className="card shadow-sm" style={{ maxWidth: '400px', width: '100%' }}>
                <div className="card-body p-4 p-md-5">
                    <div className="text-center mb-4">
                        <img src="/assets/images/logo.png" alt="Company Logo" width="150" />
                        <h4 className="mt-3">Set a New Password</h4>
                    </div>

                    {error && <div className="alert alert-danger">{error}</div>}
                    {successMessage && <div className="alert alert-success">{successMessage}</div>}

                    <form onSubmit={handleSubmit} noValidate>
                        <div className="mb-3">
                            <label className="form-label">Email Address</label>
                            <input
                                className="form-control"
                                type="email"
                                value={email}
                                readOnly // User should not change the email
                            />
                        </div>

                        <div className="mb-3">
                            <label className="form-label">New Password</label>
                            <div className="position-relative">
                                <input
                                    className="form-control"
                                    name="password"
                                    type={showPassword ? 'text' : 'password'}
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    placeholder="Enter new password"
                                    disabled={!!successMessage}
                                />
                                <span className="password-toggle-icon" onClick={() => setShowPassword(!showPassword)}>
                                    <i className={showPassword ? "ri-eye-fill" : "ri-eye-off-fill"}></i>
                                </span>
                            </div>
                        </div>

                        <div className="mb-4">
                            <label className="form-label">Confirm New Password</label>
                            <div className="position-relative">
                                <input
                                    className="form-control"
                                    name="confirmPassword"
                                    type={showConfirmPassword ? 'text' : 'password'}
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    placeholder="Confirm new password"
                                    disabled={!!successMessage}
                                />
                                <span className="password-toggle-icon" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                                    <i className={showConfirmPassword ? "ri-eye-fill" : "ri-eye-off-fill"}></i>
                                </span>
                            </div>
                        </div>

                        <div className="d-grid">
                            <button type="submit" className="btn btn-success" disabled={isLoading || !!successMessage}>
                                {isLoading ? 'Resetting...' : 'Reset Password'}
                            </button>
                        </div>
                    </form>
                    
                    <div className="text-center mt-4">
                        <Link to="/" className="text-muted">Back to Home</Link>
                    </div>
                </div>
            </div>
        </div>
    );
}